import { ArrayOpType } from '@tencent/slide-sdk-model';
import { deleteNullAttr } from './object-path';

export function changeArrAppendToSetOrModify(obj): void {
    for (const key in obj) {
        if (!obj[`${key}Op`]) {
            if (Array.isArray(obj[key])) {
                // 如果是数组，并且没有设置过Op操作符，则修改arr的默认行为
                const hasValueArr = obj[key].filter(e => !isUndefinedValOrArr(e));
                const modifyOneItem = hasValueArr.length !== obj[key].length && hasValueArr.length === 1;
                // const justOneItem = obj[key].length === 1;
                if (modifyOneItem) {
                    // (1)形如[xx, undefined, undefined,]格式的，说明是要修改有值的那项
                    const opIndex = obj[key].findIndex(e => !isUndefinedValOrArr(e));
                    obj[`${key}Op`] = { opType: ArrayOpType.Modify, opIndex };
                    // modify要求数组长度为1，所以直接抛弃其他项
                    obj[key] = [obj[key][opIndex]];
                    // 继续深层检查，因为可能多层级modify
                    changeArrAppendToSetOrModify(obj[key][0]);
                } else {
                    // 其余场景均为set
                    obj[`${key}Op`] = { opType: ArrayOpType.Set };
                    // set场景删除null
                    deleteNullAttr(obj[key]);
                }
            }
            if (typeof obj[key] === 'object' && (obj[`${key}Op`]?.opType !== ArrayOpType.Set)) {
                // 如果在上面已被加上Set标签，则无需继续向子节点继续，因为整个节点都是新增
                changeArrAppendToSetOrModify(obj[key]);
            }
        }
    }
}

function isUndefinedValOrArr(val) {
    if (Array.isArray(val)) {
        return !val.some(e => e !== undefined);
    }
    if (Object.prototype.toString.call(val) === '[object Object]') {
        const keys = Object.keys(val);
        if (keys.length === 1) {
            return isUndefinedValOrArr(val[keys[0]]);
        }
    }
    return val === undefined;
}
